
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import AuditService from '@/services/audit.service';
import {
  EShopField,
} from '@/common/enum/shop';

@Component({})
export default class extends Vue {
  visible = false;

  @Prop()
  multipleData?: any;

  @lazyInject(AuditService)
  protected auditService!: AuditService;

  EShopField = EShopField;

  atagName: any = '';

  init() {
    this.visible = true;
    if (Object.prototype.hasOwnProperty.call(this.multipleData, EShopField.MAIN_BUSINESS_ATAG_CODE)) {
      this.mainBusinessAtag(this.multipleData[EShopField.MAIN_BUSINESS_ATAG_CODE]);
    }
  }

  checkboxArray: any = {
    1: '洗车',
    2: '汽车保养',
    3: '钣金喷漆',
    4: '轮胎养护',
    5: '美容装潢',
    6: '汽车维修',
  };

  shopFields: { [key: string]: any } = {
    [`${EShopField.NAME}`]: {
      labelName: '修改店铺名称',
    },
    [`${EShopField.ADDRESS}`]: {
      labelName: '修改店铺地址',
    },
    [`${EShopField.ADVERTISER_MOBILE_PHONE_NUMBER}`]: {
      labelName: '修改广告主电话',
    },
    [`${EShopField.MANAGER_TELS}`]: {
      labelName: '修改经理电话',
    },
    [`${EShopField.START_TIME}`]: {
      labelName: '修改开业时间',
      label: EShopField.START_TIME,
    },
    [`${EShopField.MAIN_BUSINESS}`]: {
      labelName: '修改经营范围',
    },
    [`${EShopField.MAIN_BUSINESS_ATAG_CODE}`]: {
      labelName: '修改主营业务',
    },
    [`${EShopField.TELS}`]: {
      labelName: '修改行业电话',
    },
    [`${EShopField.PRE_TELS}`]: {
      labelName: '修改营业电话',
    },
    [`${EShopField.BUSINESS_TIME}`]: {
      labelName: '修改营业时间',
    },
    [`${EShopField.SHOP_VIDEOS}`]: {
      labelName: '修改店铺视频',
    },
    [`${EShopField.VIDEOS}`]: {
      labelName: '修改实拍视频（门店审核）',
    },
    [`${EShopField.SHOP_IMAGES}`]: {
      labelName: '修改店铺图片',
    },
    [`${EShopField.SHOP_LICENSE}`]: {
      labelName: '修改营业执照',
    },
    [`${EShopField.OTHER_QUALIFICATIONS}`]: {
      labelName: '修改其他资质',
    },
    [`${EShopField.BOSS_ID_IMAGES}`]: {
      labelName: '修改身份证',
    },
    [`${EShopField.STAFF}`]: {
      labelName: '修改子账户管理',
    },
    [`${EShopField.INDUSTRY_LICENSE}`]: {
      labelName: '修改行业资质',
    },
    [`${EShopField.SHOP_LICENSE_VALID_UNTIL}`]: {
      labelName: '修改营业执照有效期',
    },
    [`${EShopField.SHOP_LICENSE_VALID_DATE_TYPE}`]: {
      labelName: '修改营业执照有效期类型',
    },
     sf_photos: {
      labelName: '修改店铺门头照',
    },
    point: {
      labelName: '修改扎点信息',
    },
  };

  handleOk() {
    this.$emit('funModifyShop');
    this.visible = false;
  }

  handleCancel() {
    this.visible = false;
  }

  async mainBusinessAtag(val: any) {
    const params = {
      amapAtagId: val,
    };
    const res = await this.auditService.mainBusinessAtagList(params);
    if (res) {
      this.atagName = res.name;
    }
  }
}
